import React from 'react';
import { components } from 'react-select';
import { FAIcon } from '../../fa-icon';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import { Checkbox, Layout, Typography } from '../../../core';

const { Option } = components;

export const SelectCheckboxOption = props => {
  const { isMulti, isSelected, data, label, innerProps, multi, selectProps, useRightCheckmark, helperText, children } =
    props;
  const formattedName = selectProps?.name?.replace?.('[]', '') ?? '';
  const name = formattedName ? `-${formattedName}` : '';
  const optionIndex = selectProps?.options?.map?.(option => option?.label)?.indexOf?.(label);
  const dataAction = `select-option-${kebabCase(label)}`;
  const dataObjectId = `Select${name}-option-${optionIndex}`;
  const multiSelect = isMulti || multi;

  return (
    <Option
      {...props}
      innerProps={{
        ...props.innerProps,
        'data-action': dataAction,
        'data-object-id': dataObjectId,
      }}
    >
      {multiSelect ? (
        <Checkbox tabIndex={-1} helpText={helperText} isChecked={isSelected}>
          {' '}
          {props.children}{' '}
        </Checkbox>
      ) : (
        <Layout variant="flex" flexDirection={'column'} justifyContent={'center'} width={'100%'}>
          <Layout variant="flex" justifyContent={'space-between'} alignItems={'center'}>
            <span>{children || label}</span>
            {isSelected && <FAIcon icon="check" style={{ marginLeft: '8px' }} />}
          </Layout>
          {helperText && (
            <Typography textStyle={'p3'} mb={0} color="var(--udl-colors-text-muted)">
              {helperText}
            </Typography>
          )}
        </Layout>
      )}
    </Option>
  );
};

SelectCheckboxOption.propTypes = {
  helperText: PropTypes.string,
  isMulti: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  multi: PropTypes.bool,
  useRightCheckmark: PropTypes.bool,
  selectProps: PropTypes.shape({
    name: PropTypes.string,
    options: PropTypes.array,
  }),
};
